import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Dashboard_Bar_API, Dashboard_Filter_API } from "../../../actions/auth";
import { Bar } from "react-chartjs-2";
import "../../../assests/css/Styless.css";

const DashboardChart = () => {
  const dispatch = useDispatch();
  const [Allusers, setAllUsers] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("MM");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedWeek, setSelectedWeek] = useState("");

  useEffect(() => {
    dispatch(Dashboard_Bar_API()).then((res) => {
      if (res.success === true) {
        setAllUsers(res.data);
      }
    });
  }, [dispatch]);

  const monthlyUsersData = Allusers.monthlyUsers || [];
  const weeklyUsersData = Allusers.weeklyUsers || [];

  // Filtered data based on selectedMonth (MM for monthly, WW for weekly)
  const dataSource =
    selectedMonth === "MM" ? monthlyUsersData : weeklyUsersData;

  const Users_Join = dataSource.map((e) => e.userJoinCount);
  const Users_verify = dataSource.map((e) => e.userVerifyCount);

  // Generate labels based on the selected data source
  const MonthYearLabels = dataSource.map((e) =>
    selectedMonth === "MM"
      ? `${e._id.month}/${e._id.year}`
      : `w${e._id.week}/${e._id.year}`
  );

  // Chart data setup
  const UsersJoinData = {
    labels: MonthYearLabels,
    datasets: [
      {
        label: "Users joined",
        data: Users_Join,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Otp verified",
        data: Users_verify,
        backgroundColor: "rgba(54, 162, 235, 1)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: { color: "black", font: { weight: "bold" } },
      },
      title: {
        display: true,
        text: "Users joined and verified",
        color: "black",
        font: { weight: "bold" },
      },
    },
    scales: {
      x: { ticks: { color: "black", font: { weight: "bold" } } },
      y: { ticks: { color: "black", font: { weight: "bold" } } },
    },
  };

  // Fetch filtered data whenever filter values change
  useEffect(() => {
    dispatch(
      Dashboard_Filter_API("", selectedYear, selectedMonth, selectedWeek)
    ).then((res) => {
      if (res.success === true) {
        setAllUsers(res.data);
      }
    });
  }, [dispatch, selectedMonth, selectedYear, selectedWeek]);

  return (
    <div className="card d-flex">
      <div className="mt-3 datepicker-card">
        <label className="ml-2 mb-0">
          <select
            value={selectedMonth}
            className="form-select w100"
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            <option value="MM">Monthly</option>
            <option value="WW">Weekly</option>
          </select>
        </label>

        <label className="ml-2 mb-0">
          <select
            className="form-select"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            <option value="">All Years</option>
            {/* Populate year options */}
            {Array.from({ length: 4 }, (_, i) => (
              <option key={i} value={new Date().getFullYear() - i}>
                {new Date().getFullYear() - i}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div className="card-body">
        <div className="chart-container" style={{ height: "400px" }}>
          <Bar data={UsersJoinData} options={options} />
        </div>
      </div>
    </div>
  );
};

export default DashboardChart;
